import { render, staticRenderFns } from "./canteen.vue?vue&type=template&id=14959e7b&scoped=true"
import script from "./canteen.vue?vue&type=script&lang=js"
export * from "./canteen.vue?vue&type=script&lang=js"
import style1 from "./canteen.vue?vue&type=style&index=1&id=14959e7b&prod&scoped=true&lang=css"
import style2 from "./canteen.vue?vue&type=style&index=2&id=14959e7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14959e7b",
  null
  
)

export default component.exports